import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/takeUntil';
import {
  MorningOvertimeReadinessPromptAnswer,
  MorningOvertimeReadinessPromptViewState
} from '../../models/morning-overtime-readiness.model';
import { MorningOvertimeReadinessFacadeService } from '../../services/morning-overtime-readiness-facade.service';

@Component({
  selector: 'app-morning-overtime-prompt-container',
  templateUrl: './morning-overtime-prompt-container.component.html',
  styleUrls: ['./morning-overtime-prompt-container.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MorningOvertimePromptContainerComponent implements OnInit, OnDestroy {
  public viewState$: Observable<MorningOvertimeReadinessPromptViewState>;
  private destroy$: Subject<void>;

  constructor(
    private facadeService: MorningOvertimeReadinessFacadeService,
    private router: Router
  ) {
    this.destroy$ = new Subject<void>();
    this.viewState$ = this.facadeService.promptState$;
  }

  public ngOnInit(): void {
    this.refreshPrompt();
    this.trackRouteChanges();
  }

  public ngOnDestroy(): void {
    this.facadeService.clearCutoffTimer();
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onSubmitAnswer(answer: MorningOvertimeReadinessPromptAnswer): void {
    this.facadeService.submitPromptAnswer(answer);
  }

  private trackRouteChanges(): void {
    this.router.events
      .filter((event) => event instanceof NavigationEnd)
      .takeUntil(this.destroy$)
      .subscribe(() => this.refreshPrompt());
  }

  private refreshPrompt(): void {
    this.facadeService.refreshPrompt();
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/morning-overtime-readiness/containers/morning-overtime-prompt-container/morning-overtime-prompt-container.component.ts